package com.nonopn.skywatcher.common.app.pages.map.model.forecast

import com.nonopn.skywatcher.common.app.pages.map.model.weather.WeatherReport
import compose.icons.WeatherIcons
import compose.icons.weathericons.Barometer
import compose.icons.weathericons.Humidity
import compose.icons.weathericons.Rain
import compose.icons.weathericons.Raindrop
import compose.icons.weathericons.Raindrops
import compose.icons.weathericons.StrongWind
import compose.icons.weathericons.Thermometer
import compose.icons.weathericons.Windy

class ForecastAggregator(
    weather: WeatherReport,
    now: String,
    nowAfter: String
) {
    val forecastLines: List<ForecastLine> = listOf(
        ForecastLine.String(
            null,
            "",
            now,
            nowAfter
        ),
        ForecastLine.Float(
            WeatherIcons.Thermometer,
            " °C",
            weather.temperature.now,
            weather.temperature.later
        ),
        ForecastLine.Int(
            WeatherIcons.Humidity, // -> humidity
            " %",
            weather.humidity.now,
            weather.humidity.later,
            GraphValue(
                weather.humidity.now / 100.0f,
                GraphColorsType.Humidity
            )
        ),
        ForecastLine.Int(
            WeatherIcons.Rain, // -> rain
            " %",
            weather.rainProbability.now,
            weather.rainProbability.later,
            GraphValue(
                weather.rainProbability.now / 100.0f,
                GraphColorsType.Rain
            )
        ),
        ForecastLine.Float(
            WeatherIcons.Raindrop, // -> rain level
            " mm",
            weather.rainLevel.now,
            weather.rainLevel.later
        ),
        ForecastLine.Double(
            WeatherIcons.Barometer,
            " hPa",
            weather.pressure.now,
            weather.pressure.later,
        ),
        ForecastLine.Float(
            WeatherIcons.Windy,
            " Km/h",
            weather.windSpeed.now,
            weather.windSpeed.later,
        ),
        ForecastLine.Float(
            WeatherIcons.StrongWind,
            " Km/h",
            weather.windGust.now,
            weather.windGust.later,
        ),
    )
}